// extracted by mini-css-extract-plugin
export default {"advertisement-box":"SSCvR0ThDDvY9IbWEKJp","common_bganimation":"UTBEjmxXGx_ksp9KHjcV"};